<template>
  <div class="wrapper">
    <div class="content" ref="content">
      <div style="height:100%">
        <el-menu default-active="1" mode="horizontal">
          <el-menu-item index="1">UCP Converter</el-menu-item>
        </el-menu>
        <br>
        <el-form :inline="true" :model="ucp" ref="ucp" class="form" label-position="left"
                 label-width="100px" style="margin: 0 16px">
          <el-form-item prop="payload">
            <el-input type="textarea" v-model="ucp.payload" placeholder="Payload" v-bind:style="{width: textAreaWidth + 'px'}" @input="handlePayloadType()" autofocus rows="5" resize="both"></el-input>
          </el-form-item>
          <br>
          <el-form-item label="Encoding:" prop="payloadType">
            <el-select v-model="ucp.payloadType" placeholder="Payload Type" v-bind:style="{width: itemWidth + 'px'}">
              <el-option
                v-for="item in payloadTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Mode:" prop="mode">
            <el-select v-model="ucp.mode" placeholder="Mode" v-bind:style="{width: itemWidth + 'px'}" @change="handleMode()">
              <el-option
                v-for="item in mode"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Device Type:" prop="deviceType">
            <el-select v-model="ucp.deviceType" placeholder="Device Type" v-bind:style="{width: itemWidth + 'px'}">
              <el-option
                v-for="item in deviceTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="UCP Version:" prop="ucpVersion">
            <el-select v-model="ucp.version" placeholder="UCP Version" v-bind:style="{width: itemWidth + 'px'}">
              <el-option
                v-for="item in versions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="convert" v-bind:style="{'margin-left': '100px', width: itemWidth + 'px'}">Convert
          </el-button>
        </el-form>
        <el-alert v-if="error" :title="error" type="error" :closable="false"></el-alert>
        <div class="box-card" v-for="(item, index) in data" style="margin: 15px;">
          <el-card>
            <el-tag style="margin-bottom: 10px;" v-if="data.length > 1"> {{ index + 1 }}</el-tag>
            <el-alert v-if="item.raw" :title="item.raw" type="info" :closable="false"
                      style="margin: 0 0 10px 0; word-break: break-all"></el-alert>
            <ucp-table v-if="isTableShow" :col="item.table.tableHead" :data="item.table.tableRows"></ucp-table>
            <el-alert v-if="item.error" :title="item.error" type="error" :closable="false"
                      style="margin-top: 10px;"></el-alert>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Parser from '../../lib/ucp/converter'
  import UcpTable from '../util/ucp-table'

  export default {
    components: {UcpTable},
    mounted () {
      const self = this;
      window.onresize = () => {
        self.$nextTick(() => {
          const width = self.$refs.content.clientWidth;
          self.textAreaWidth = width - 112;
          self.itemWidth = (width - 112) / 5 > 200 ? ((width - 170) / 5) - 100 : 100;
        });
      };
    },
    data() {
      return {
        textAreaWidth: window.innerWidth - 112,
        itemWidth: (window.innerWidth - 112) / 5 > 200 ? ((window.innerWidth - 170) / 5) - 100 : 100,
        isTableShow: false,
        ucp: {
          payload: '',
          version: 'v1.1',
          deviceType: 'DIGIT',
          payloadType: 'hex',
          mode: "cloud"
        },
        payloadTypes: [
          {
            label: 'Hex',
            value: 'hex'
          },
          {
            label: 'Base64',
            value: 'base64'
          }
        ],
        mode: [
          {
            label: 'Cloud',
            value: 'cloud'
          },
          {
            label: 'LoRa',
            value: 'lora'
          },
          {
            label: 'IPSO',
            value: 'ipso'
          }
        ],
        deviceTypes: [
          {
            label: 'Digit',
            value: 'DIGIT'
          },
          {
            label: 'Analog',
            value: 'ANALOG'
          },
          {
            label: 'UART',
            value: 'UART'
          }
        ],
        versions: [
          {
            label: 'v1.1',
            value: 'v1.1'
          },
          {
            label: 'v1.2',
            value: 'v1.2'
          },
          {
            label: 'v1.3',
            value: 'v1.3'
          },
        ],
        data: [],
        error: null,
      }
    },
    methods: {
      convert() {
        // 强制重新生成组件, 避免监听器bug
        this.isTableShow = false;
        this.$nextTick(() => {
          let res = Parser.parseToJson(this.ucp.payload, this.ucp.deviceType, this.ucp.version, this.ucp.payloadType, this.ucp.mode);
          this.error = res.error;
          // console.log(JSON.stringify(res, null, 2));
          this.data = res.data;
          if (this.data.length > 0) {
            this.isTableShow = true;
          }
          this.$nextTick(() => {
            const width = this.$refs.content.clientWidth;
            this.textAreaWidth = width - 112;
            this.itemWidth = (width - 112) / 5 > 200 ? ((width - 170) / 5) - 100 : 100;
          });
        });
      },
      handleMode() {
        if (this.ucp.mode === "ipso") {
          this.ucp.deviceType = "t1";
          this.ucp.version = "v1";
          this.deviceTypes = [
            {
              label: 'T1',
              value: 't1'
            },
            {
              label: 'N1',
              value: 'n1'
            },
            {
              label: 'UC11/EM/AM',
              value: '11'
            },
          ];
          this.versions = [
            {
              label: 'v1',
              value: 'v1'
            }
          ];
        } else {
          this.ucp.deviceType = "DIGIT";
          this.ucp.version = "v1.1";
          this.deviceTypes = [
            {
              label: 'Digit',
              value: 'DIGIT'
            },
            {
              label: 'Analog',
              value: 'ANALOG'
            },
            {
              label: 'UART',
              value: 'UART'
            }
          ];
          this.versions = [
            {
              label: 'v1.1',
              value: 'v1.1'
            },
            {
              label: 'v1.2',
              value: 'v1.2'
            },
            {
              label: 'v1.3',
              value: 'v1.3'
            },
          ];
          if(this.ucp.mode === "lora") {
            this.versions = [
              {
                label: 'v1.1',
                value: 'v1.1'
              },
              {
                label: 'v1.2',
                value: 'v1.2'
              },
            ];
          }
        }
      },
      handlePayloadType() {
        const payload = this.ucp.payload;
        let isHex = true;
        isHex = payload.length % 2 === 0 && payload.search(/[^0-9a-fA-F]/g) < 0;
        if (isHex) {
          this.ucp.payloadType = "hex";
          const payload = this.ucp.payload.toLowerCase();
          if ((payload.startsWith("7e") || payload.startsWith("0x7e")) && this.ucp.mode === "ipso") {
            this.ucp.deviceType = "DIGIT";
            this.ucp.version = "v1.1";
            this.ucp.mode = "cloud";
            this.deviceTypes = [
              {
                label: 'Digit',
                value: 'DIGIT'
              },
              {
                label: 'Analog',
                value: 'ANALOG'
              },
              {
                label: 'UART',
                value: 'UART'
              }
            ];
            this.versions = [
              {
                label: 'v1.1',
                value: 'v1.1'
              },
              {
                label: 'v1.2',
                value: 'v1.2'
              },
              {
                label: 'v1.3',
                value: 'v1.3'
              },
            ];
          } else if (payload.length > 0
            && !(payload.startsWith("7e") || payload.startsWith("0x7e")) && this.ucp.mode !== "ipso") {
            this.ucp.deviceType = "t1";
            this.ucp.version = "v1";
            this.ucp.mode = "ipso";
            this.deviceTypes = [
              {
                label: 'T1',
                value: 't1'
              },
              {
                label: 'N1',
                value: 'n1'
              },
              {
                label: 'UC11/EM/AM',
                value: '11'
              },
            ];
            this.versions = [
              {
                label: 'v1',
                value: 'v1'
              }
            ];
          }
        } else if (/^[A-Za-z\d+/]*([A-Za-z\d+/][A-Za-z\d+/=]|==)$/g.test(payload)) {
          this.ucp.payloadType = "base64";
        }
      }
    }// methods
  }// vue
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/Converter.vue